import React from "react";
import "./Slider.css";
import { Carousel } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";

function Slider() {
  const [movies, setMovies] = React.useState([]);

  const getMovies = async () => {
    const response = await axios({
      method: "GET",
      url: `https://api.themoviedb.org/3/movie/upcoming?api_key=${process.env.REACT_APP_API_KEY}`,
      params: {
        include_adult: false,
      },
    });

    setMovies(response.data.results);
  };

  React.useEffect(() => {
    getMovies().catch(alert);
  }, []);

  return (
    <div>
      <div id="custom-carousel">
        <Carousel indicators={false} controls={false}>
          {movies.map((movie) => (
            <Carousel.Item key={movie.id}>
              <Link
                className="navbar-custom-nav-link"
                to={`/movie/${movie.id}`}
              >
                <img
                  className="d-block w-100 opacity-50"
                  src={`https://image.tmdb.org/t/p/w1280${movie.backdrop_path}`}
                  alt="First slide"
                />
                <Carousel.Caption>
                  <h2>{movie.title}</h2>
                  <hr />
                  {/* <p>{movie.overview}</p> */}
                </Carousel.Caption>
              </Link>
            </Carousel.Item>
          ))}
        </Carousel>
        {/* <Carousel>
          {movies.map((movie) => (
            <Carousel.Item key={movie.id}>
              <Link
                className="navbar-custom-nav-link"
                to={`/movie/${movie.id}`}
              >
                <img
                  className="slider-img"
                  src={`https://image.tmdb.org/t/p/w1280${movie.backdrop_path}`}
                  alt="First slide"
                />
                <Carousel.Caption>
                  <h3>{movie.title}</h3>
                  <hr />
                  <p>{movie.overview}</p>
                </Carousel.Caption>
              </Link>
            </Carousel.Item>
          ))}
        </Carousel> */}
      </div>
    </div>
  );
}

export default Slider;
